import { render, staticRenderFns } from "./CreatePortfolio.vue?vue&type=template&id=059857b6&scoped=true&"
import script from "./CreatePortfolio.vue?vue&type=script&lang=js&"
export * from "./CreatePortfolio.vue?vue&type=script&lang=js&"
import style0 from "./CreatePortfolio.vue?vue&type=style&index=0&id=059857b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059857b6",
  null
  
)

export default component.exports